<script lang="ts">
  import { fly } from 'svelte/transition';

  import type { AlertOverlay } from './api';

  export let alert: AlertOverlay;

  const iconMap: Record<string, string> = {
    ALERT: '⚠️',
    INFO: 'ℹ️',
    PROMO: '🎁',
    CLOSED: '🚫',
    WARNING: '⚡',
    BIRTHDAY: '🎂',
  };

  $: icon = iconMap[alert.icon] ?? 'ℹ️';
  $: iconColor = colorFor(alert.icon);

  function colorFor(name: string): string {
    switch (name) {
      case 'ALERT':
      case 'WARNING':
        return '#ef4444';
      case 'CLOSED':
        return '#374151';
      case 'PROMO':
      case 'BIRTHDAY':
        return '#f59e0b';
      case 'INFO':
      default:
        return '#0ea5e9';
    }
  }
</script>

<div class="overlay" transition:fly={{ y: 100, duration: 400 }} style="--icon-color: {iconColor}">
  <div class="icon">{icon}</div>
  <div class="text">{alert.text}</div>
</div>

<style>
  .overlay {
    position: absolute;
    bottom: 5vh;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.85);
    color: white;
    padding: 1.5rem 2.5rem;
    border-radius: 1rem;
    display: flex;
    align-items: center;
    gap: 1.5rem;
    max-width: 80vw;
    backdrop-filter: blur(20px);
    border: 2px solid var(--icon-color);
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);
    z-index: 100;
  }
  .icon {
    font-size: 4rem;
    line-height: 1;
  }
  .text {
    font-size: 2.5rem;
    line-height: 1.2;
    font-weight: 600;
    flex: 1;
  }
</style>
